import { devLog } from '@/utils'

/**
 * Permet à une instance de vue d'être disponible dans le devTools
 */
export default {
  created () {
    if (process.env.DEV) {
      try {
        const node = document.createElement('div')
        document.body.appendChild(node)
        this.$mount(node)
      } catch (e) {
        devLog('error', e)
      }
    }
  },
  render (createElement, context) {
    return createElement('div')
  }
}
